define('SC.HideQuantityPricing.1.0.0.HideQuantityPricing', [
    'SC.Configuration',
    'Profile.Model',

    'HideQuantityPricing.View'
], function HandlebarsHelper (
    Configuration,
    ProfileModel,

    HideQuantityPricingView
) {

    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var pdp = application.getComponent('PDP');
            var showPrice = !ProfileModel.getInstance().hidePrices();

            if (!showPrice) {
                pdp.addChildViews(
                    pdp.PDP_FULL_VIEW, {
                        'Quantity.Pricing': {
                            'Quantity.Pricing': {
                                childViewIndex: 5,
                                childViewConstructor: function childViewConstructor() {
                                    return new HideQuantityPricingView({
                                        message: 'Please log in to see quantity discount or purchase this item',
                                        items: pdp.getItemInfo(),
                                        pdp: pdp
                                    });
                                }
                            }
                        }
                    }
                );

                pdp.addChildViews(
                    pdp.PDP_QUICK_VIEW, {
                        'Quantity.Pricing': {
                            'Quantity.Pricing': {
                                childViewIndex: 5,
                                childViewConstructor: function childViewConstructor() {
                                    return new HideQuantityPricingView({
                                        message: 'Please log in to see quantity discount or purchase this item',
                                        items: pdp.getItemInfo(),
                                        pdp: pdp
                                    });
                                }
                            }
                        }
                    }
                );
            }
        }
    };
});
